import React, { useState } from "react";
import { Box, Tooltip } from "@mui/material";
import Colors from "../../../common/Colors";
import Text from "../../../components/Text";
import assets from "../../../common/assets";

function Tables({ data, handleClick, selectedTableId, onHover }) {
  const [tooltipData, setTooltipData] = useState({});
  const [hoveredTable, setHoveredTable] = useState(null);

  const handleMouseEnter = async (table) => {
    if (table.table_status !== "1") return; // Skip if table is vacant
    
    setHoveredTable(table.id);
    
    // Only fetch if we don't already have the data
    if (!tooltipData[table.id]) {
      const data = await onHover(table);
      if (data) {
        setTooltipData(prev => ({
          ...prev,
          [table.id]: data
        }));
      }
    }
  };

  const handleMouseLeave = () => {
    setHoveredTable(null);
  };

  const renderTable = (item, index) => {
    const {
      call_waiter,
      id,
      table_capacity,
      table_no,
      table_status,
      table_status_on_off,
    } = item;

    const isSelected = selectedTableId == id;
    const isOccupied = table_status === "1";
    const isCallWaiter = call_waiter === 1;
    const isUnderMaintenance = table_status_on_off === 0;
    const tableData = tooltipData[id];

    return (
      <Tooltip
  title={
    isOccupied && hoveredTable === id && tableData ? (
      <div style={{ 
        padding: "8px 12px",
        backgroundColor: "#041A29",
        color: "white",
        borderRadius: "6px",
        minWidth: "160px",
        // boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        fontSize: "14px",
        fontWeight: "500"
      }}>
        <div style={{ marginBottom: "4px" }}>⏱️ Duration: {tableData.duration}</div>
        <div>💰 Total: {tableData.currency}{tableData.total}</div>
      </div>
    ) : ""
  }
  arrow
  placement="top"
  componentsProps={{
    tooltip: {
      sx: {
        backgroundColor: "#041A29",
        '& .MuiTooltip-arrow': {
          color: "#BB0041A29A21",
        },
      },
    },
  }}
>
        <button
          key={index}
          style={{
            minWidth: 60,
            minHeight: 25,
            backgroundColor: isSelected
              ? Colors.btnColor
              : isOccupied
              ? isCallWaiter
                ? Colors.redColor
                : Colors.greenColor
              : "#041A29",
            margin: 2,
            borderRadius: 5,
            border: "none",
            position: "relative",
            cursor: isUnderMaintenance ? "not-allowed" : "pointer",
            opacity: isUnderMaintenance ? 0.6 : 1,
            transition: "transform 0.2s",
            transform: hoveredTable === id ? "scale(1.05)" : "scale(1)",
          }}
          onClick={() => {
            if (isUnderMaintenance) {
              alert("This table is under maintenance.");
              return;
            }
            handleClick(item, index);
          }}
          onMouseEnter={() => handleMouseEnter(item)}
          onMouseLeave={handleMouseLeave}
          disabled={isUnderMaintenance}
        >
          {/* Table No */}
          <Text
            style={{
              color: isSelected ? "black" : "white",
            }}
            semibold
          >
            {table_no ?? id}
          </Text>

          {/* Call Waiter Icon */}
          {isCallWaiter && (
            <img
              src={assets.callwaiter}
              alt="Call Waiter"
              style={{
                position: "absolute",
                top: 5,
                right: 5,
                width: 15,
                height: 15,
                animation: "pulse 1.5s infinite",
              }}
            />
          )}

          {/* Maintenance Lock Icon */}
          {isUnderMaintenance && (
            <img
              src={assets.personIcon}
              alt="Under Maintenance"
              style={{
                position: "absolute",
                bottom: 5,
                right: 5,
                width: 15,
                height: 15,
              }}
            />
          )}
        </button>
      </Tooltip>
    );
  };

  return (
    <div style={{ margin: "10px 0px" }}>
      {data.length > 0 ? (
        data.map((item, index) => (
          <React.Fragment key={index}>{renderTable(item, index)}</React.Fragment>
        ))
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 100,
          }}
        >
          No Tables Found
        </div>
      )}
      <style jsx>{`
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.2); opacity: 0.7; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
}

export default Tables;